import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "module-common/Modal";
import Icon from "module-common/Icon";

export default class CaseNotes extends Component {
  static propTypes = {
    content: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func
  };

  render() {
    const { content } = this.props;
    return (
      <Modal>
        <Wrapper>
          <Text>Case Notes</Text>
          <Content>{content}</Content>
          <XIcon
            name="x-button-blue"
            mode="contain"
            width={30}
            height={30}
            onClick={this.props.onClose}
          />
        </Wrapper>
      </Modal>
    );
  }
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 350px;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 10px;
`;
const Content = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 4px;
`;
const XIcon = styled(Icon)`
  position: absolute;
  top: -15px;
  right: -15px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/header/CaseNotes.js